<template>
  <div style="padding: 20px 0 0 0;color:black" >
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="发货编号：" v-if="prentType != 'smallBag'">
        <el-input maxlength='50' v-model="formInline.deliveryTaskCode" placeholder="请输入发货编号"></el-input>
      </el-form-item>
      <el-form-item label="订单编号：" v-if="prentType == 'smallBag'">
        <el-input maxlength='50' v-model="formInline.platformOrderNo" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input maxlength='100' v-model="formInline.productName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="原货代公司：">
        <el-select v-model="formInline.intForwarderConfigId" placeholder="全部" filterable >
          <el-option label="全部" :value="''"></el-option>
          <el-option :label="item.forwarder + '-' + item.shippingType + `(${item.currentReviewTotal || 0})`" :title="item.forwarder + '-' + item.shippingType"
            :value="item.intForwarderConfigId" :disabled="!item.currentReviewTotal > 0" v-for="(item,index) in forwarder" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核后货代公司：" v-if="tableType =='ToBeConfirm' || tableType == 'Completed'">
        <el-select v-model="formInline.auditIntForwarderConfigId" placeholder="全部" filterable>
          <el-option label="全部" :value="''"></el-option>
          <el-option :label="item.forwarder + '-' + item.shippingType + `(${item.currentReviewTotal || 0})`" :title="item.forwarder + '-' + item.shippingType"
            :value="item.intForwarderConfigId" :disabled="!item.currentReviewTotal > 0" v-for="(item,index) in forwarder" :key="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称：">
        <el-input maxlength='100' v-model="formInline.customerShopName" placeholder="请输入店铺名称"></el-input>
      </el-form-item>
      <el-form-item label="申报信息完善性：">
        <el-select v-model="formInline.completeReportingInfo" placeholder="全部">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="完善" :value="1"></el-option>
          <el-option label="不完善" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="formInline.createDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="timeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="审单人：" v-if="tableType == 'ToBeConfirm' || tableType == 'Completed'">
        <el-input maxlength='50' v-model="formInline.auditName" placeholder="请输入审单人"></el-input>
      </el-form-item>
      <el-form-item label="审单日期：" v-if="tableType == 'ToBeConfirm' || tableType == 'Completed'">
        <el-date-picker v-model="formInline.auditDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="auditTimeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="确认日期：" v-if="tableType == 'Completed'">
        <el-date-picker v-model="formInline.confirmDate" type="daterange" range-separator="至" start-placeholder="开始日期"
          @change="confirmTimeChange" end-placeholder="结束日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="MINI订单：" v-if="prentType == 'smallBag' && tableType == 'ToBeProcessed'">
        <el-switch v-model="formInline.miniFlag"></el-switch>
      </el-form-item>
      <el-form-item label="审单方式：" v-if="tableType == 'Completed' && prentType === 'smallBag'">
        <el-select v-model="formInline.reviewMethod" placeholder="全部">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="自动审单" :value="1"></el-option>
          <el-option label="手动审单" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="tiktok订单：" v-if="prentType === 'smallBag'">
        <el-select v-model="formInline.tiktokOrderFlag" placeholder="全部">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "InterForm",
  props: {
    prentType: {
      type: String,
      required: true,
    },
    forwarder: {
      type: Array,
      default: () => []
    },
    tableType: {
      type: String,
      default: () => 'ToBeProcessed'
    }
  },
  data() {
    return {
      storeList: [],
      formInline: {
        deliveryTaskCode: "",
        completeReportingInfo:'',
        intForwarderConfigId: '',
        auditIntForwarderConfigId:'',
        tiktokOrderFlag: undefined
      },
    };
  },
  created() {
    this.$emit("querySubmit", this.formInline);
  },
  methods: {
    cascaderChang: function (val) {
      // formInline.shopName
    },
    remoteMethod(val) {
      if (!val) {
        return;
      }
      console.log(val);
      getCustomerShopListApi({
        pageSize: 10000,
        pageNum: 1,
        customerShopName: val
      }).then((res) => {
        console.log(res)
        this.storeList = res.data.records;
      });
    },
    timeChange: function (val) {
      if (!val) {
        this.formInline.createStartTime = null;
        this.formInline.createEndTime = null;
        return;
      }
      this.formInline.createStartTime = moment(val[0]).format("YYYY-MM-DD");
      this.formInline.createEndTime = moment(val[1]).format("YYYY-MM-DD");
    },
    auditTimeChange: function (val) {
      if (!val) {
        this.formInline.auditStartTime = null;
        this.formInline.auditEndTime = null;
        return;
      }
      this.formInline.auditStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.formInline.auditEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    confirmTimeChange: function (val) {
      if (!val) {
        this.formInline.confirmStartTime = null;
        this.formInline.confirmEndTime = null;
        return;
      }
      this.formInline.confirmStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.formInline.confirmEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    onSubmit: function (e, type = "") {
      const info = {...this.formInline}
      console.log(info)
      this.$emit("querySubmit", info);
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => { this.formInline[key] = '' })
      this.formInline.completeReportingInfo = ''
      this.formInline.miniFlag = 0
      // this.formInline.singleProduct = this.prentType === "smallBag" ? 0 : '',
      this.onSubmit(undefined, "rest");
    },
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
